import { render, staticRenderFns } from "./BaseWidget.vue?vue&type=template&id=f3081ca4&"
import script from "./BaseWidget.vue?vue&type=script&lang=js&"
export * from "./BaseWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports